import Datatable from "@/components/tables/datatable";
import { useGetBonusClaims } from "@/services/depositbonus.service";
import { getKeyValue } from "@nextui-org/react";
import { format } from "date-fns";
import { Key, useCallback } from "react";

const columns: any[] = [
  {
    key: "username",
    label: "Username",
  },
  {
    key: "transactionId",
    label: "Transaction ID",
  },
  {
    key: "bonusName",
    label: "Bonus Name",
  },
  {
    key: "bonusCode",
    label: "Bonus Code",
  },
  {
    key: "depositAmount",
    label: "Deposit Amount",
  },
  {
    key: "bonusAmount",
    label: "Bonus Amount",
  },
  {
    key: "releaseThreshold",
    label: "Release Threshold",
  },
  {
    key: "status",
    label: "Status",
  },
  {
    key: "createdAt",
    label: "Claimed At",
  },
];

export const DepositBonusClaimList = () => {
  const query = useGetBonusClaims;

  const renderCell = useCallback((data: any[], item: any, columnKey: Key) => {
    switch (columnKey) {
      case "createdAt":
        return (
          <div className="font-normal">
            {format(
              getKeyValue(item, columnKey as string),
              "dd/MM/yyyy HH:mm:ss",
            ) || "-"}
          </div>
        );

      case "depositAmount":
      case "bonusAmount":
      case "releaseThreshold":
        return (
          <div className="font-normal">
            {(getKeyValue(item, columnKey as string) as number).toLocaleString(
              undefined,
              {
                maximumFractionDigits: 2,
              },
            ) || "0"}
          </div>
        );

      case "percentage":
        return (
          <div className="font-normal">
            {parseFloat(getKeyValue(item, columnKey as string) || "0") * 100}%
          </div>
        );

      case "releaseMultiplier":
        return (
          <div className="font-normal">
            {getKeyValue(item, columnKey as string) || "0"}X
          </div>
        );

      default:
        return (
          <div className="font-normal">
            {getKeyValue(item, columnKey as string) || "-"}
          </div>
        );
    }
  }, []);

  return (
    <div>
      <Datatable
        columns={columns}
        searchFields={[{ label: "Bonus Code", value: "bonusCode" }]}
        renderCell={renderCell}
        query={query}
        customQueryFilter={{}}
        customFilters={[]}
      />
    </div>
  );
};
